import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { usePageMeta } from '../hooks/usePageMeta';
import RequestForm from '../components/RequestForm';
import ScrollToTop from '../components/ScrollToTop';
import Hero from '../components/Hero';

const Request = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage].requestForm;
  usePageMeta({ title: t.title, description: t.subtitle, path: 'request' });

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero
        gradientClass="hero-gradient-request"
        title={t.title}
        description={t.subtitle}
      />

      {/* Form Section */}
      <div className="bg-stone-100 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <RequestForm />
        </div>
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Request;
